import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

export const paymentList = createAsyncThunk('paymentList', async ({ role_id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `payment?role_id=${role_id || ''}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const paymentListSlice = createSlice({
    name: 'paymentList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(paymentList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => {
                    const raw = action.payload.data.data;
                    return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []);
                })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(paymentList.rejected, () => { })
    }
})

export default paymentListSlice.reducer;
